import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormDiamond: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="form-diamond, square-45-degrees"><path d="M22.8086 12L11.998 22.8105L1.1875 12L11.998 1.18945L22.8086 12Z" fill="currentColor"/></CentralIconBase>;
};

export default IconFormDiamond;
